import { BaseFetch } from "../main-model"
export default class ReportInsuranceSmsModel extends BaseFetch {
    getReportInsuranceSmsBy = (data) =>
    this.authFetch({
      url: "report-insurance-sms/getReportInsuranceSmsBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportInsuranceSmsById = (data) =>
    this.authFetch({
      url: "report-insurance-sms/getReportInsuranceSmsById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertReportInsuranceSms = (data) =>
    this.authFetch({
      url: "report-insurance-sms/insertReportInsuranceSms",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateReportInsuranceSmsById = (data) =>
    this.authFetch({
      url: "report-insurance-sms/updateReportInsuranceSmsById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteReportInsuranceSmsById = (data) =>
    this.authFetch({
      url: "report-insurance-sms/deleteReportInsuranceSmsById",
      method: "POST",
      body: JSON.stringify(data),
    })

}
